<template>
	<div>
		<div>
			<el-radio-group v-model="radio" @change="rbtnChanged()">
				<el-radio-button :label="0">未预约</el-radio-button>
				<el-radio-button :label="1">已预约</el-radio-button>
			</el-radio-group>
		</div>
		<el-table border ref="multipleTable" tooltip-effect="dark" :data="ShowCusList.slice((currentPage-1)*pagesize,currentPage*pagesize)">
			<el-table-column prop="cusname" label="姓名" width="160px"></el-table-column>
			<el-table-column prop="cussex" label="适用性别">
				<template slot-scope="scope">
					<div v-for="item in AdaptSex">
						<label v-if='scope.row.cussex==item.value'>{{item.key}}</label>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="cusmarry" label="婚否">
				<template slot-scope="scope">
					<div v-for="item1 in AdaptMarry">
						<label v-if='scope.row.cusmarry==item1.value'>{{item1.key}}</label>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="cusbirthday" label="出生日期"></el-table-column>
			<el-table-column prop="mobile" label="手机号"></el-table-column>
			<el-table-column prop="idcard" label="证件号"></el-table-column>
			<el-table-column prop="cusstatus" label="状态">
				<template slot-scope="scope">
					<div v-for="item1 in CusStatus">
						<label v-if='scope.row.cusstatus==item1.value'>{{item1.key}}</label>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="memo" label="备注"></el-table-column>
		</el-table>
		<el-footer style="margin-top:20px;">
			<template>
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
					 :page-sizes="[10, 20, 40,80]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="ShowCusList.length"></el-pagination>
				</div>
			</template>
		</el-footer>
	</div>
</template>

<script>
	export default {
		created() {
			this.OrderCusList = this.inordercuss;
			this.initData()
		},
		data() {
			return {
				OrderCusList: this.inordercuss,
				ShowCusList: [],
				BookedCusList: [],
				NoBookCusList: [],
				AdaptSex: this.$enums.AdaptSex,
				AdaptMarry: this.$enums.AdaptMarry,
				CusStatus: this.$enums.CusStatus,
				currentPage: 1,
				pagesize: 10,
				select_word: "",
				radio: "0"

			}
		},
		props: ['inordercuss'],
		methods: {
			initData() {
				if (this.inordercuss.length < 1)
					return;
				for (let i = 0; i < this.OrderCusList.length; i++) {
					if (this.OrderCusList[i].cusstatus < 30 || this.OrderCusList[i].cusstatus == '40')
						this.NoBookCusList.push(this.OrderCusList[i]);
					else
						this.BookedCusList.push(this.OrderCusList[i]);
				}
				this.rbtnChanged();
			},
			rbtnChanged() {
				if (this.radio == "0")
					this.ShowCusList = this.NoBookCusList;
				else
					this.ShowCusList = this.BookedCusList;
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
		}
	}
</script>

<style>
</style>
